import React, { useEffect, useState } from "react";
import Header from "../Core/Header";
import "../Style/Home.css";
import { ChevronDown } from "lucide-react";
import stepBg1 from "../../assets/step-card-bg.jpg";
import stepBg2 from "../../assets/coupon1.jpeg";
import Footer from "../Core/Footer";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { setPlan } from "../../redux/slices/bookingSlice";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { motion } from "motion/react";
import { searchCities } from "../../service/operations/api_methods";
import { logout } from "../../redux/slices/authSlice";
import { useMediaQuery } from "usehooks-ts";

const CouponCard = (imgUrl) => {
  return (
    <div className="coupon-card">
      <img
        src={imgUrl.imgUrl || "/Sliding/coupon1.webp"}
        alt="Summer Deal Coupon"
        className="coupon-image"
      />
    </div>
  );
};

const FAQItem = ({ question, answer, isOpen, onToggle }) => {
  return (
    <div className="faq-item">
      <button className="faq-question" onClick={onToggle}>
        <span>{question}</span>
        <ChevronDown size={24} className={`faq-icon ${isOpen ? "open" : ""}`} />
      </button>
      {isOpen && (
        <div className="faq-answer">
          <p>{answer}</p>
        </div>
      )}
    </div>
  );
};

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqData = [
    {
      question: "Can I track the location of my booked bus online?",
      answer:
        "Yes! With ROAMJSSLN PVT. LTD, you can track your bus in real-time using our mobile app or website. Once you've booked your ticket, you'll receive a tracking link that shows the exact location of your bus, estimated arrival time, and other important details.",
    },
    {
      question: "What are the advantages of bus ticket booking with ROAMJSSLN PVT. LTD?",
      answer:
        "ROAMJSSLN PVT. LTD offers numerous benefits including instant e-tickets, real-time tracking, competitive pricing, easy cancellations, secure payment options, and access to a wide network of verified bus operators. You can also enjoy exclusive deals and discounts on regular bookings.",
    },
    {
      question: "Why book bus tickets online on ROAMJSSLN PVT. LTD?",
      answer:
        "Booking on ROAMJSSLN PVT. LTD is convenient, fast, and secure. You can browse multiple options, compare prices, read reviews from other travelers, and book from anywhere at any time. Plus, you get instant confirmation and receive your e-ticket immediately via email or SMS.",
    },
    {
      question:
        "Do I need to create an account on the ROAMJSSLN PVT. LTD site to book bus ticket?",
      answer:
        "While you can make a quick booking as a guest, creating an account on ROAMJSSLN PVT. LTD allows you to save your preferences, manage bookings easily, access your booking history, and receive personalized offers and discounts. It's optional but recommended for a better experience.",
    },
  ];

  return (
    <section className="faq-section">
      <div className="faq-container">
        <h2 className="faq-title">FAQs related to Bus Booking</h2>
        <div className="faq-list">
          {faqData.map((item, index) => (
            <FAQItem
              key={index}
              question={item.question}
              answer={item.answer}
              isOpen={openIndex === index}
              onToggle={() => setOpenIndex(openIndex === index ? null : index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

const Home = () => {
  const mobile = useMediaQuery("(max-width: 767px)");
  const navigate = useNavigate();
  const token = Cookies.get("roam-token");
  const dispatch = useDispatch();
  const plan = useSelector((state) => state.booking.plan);

  const [showHeader, setShowHeader] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const today = new Date().toISOString().split("T")[0];
  const [boarding, setBoarding] = useState(plan?.boarding || "");
  const [dropping, setDropping] = useState(plan?.dropping || "");
  const [time, setTime] = useState(today || "");
  const [fromCity, setFromCity] = useState([]);
  const [destinationCity, setDestinationCity] = useState([]);
  const [rotated, setRotated] = useState(true);

  const inputRef = React.useRef(null);

  const images = [
    "/Sliding/bus-11.jpg",
    "/Sliding/bus-12.jpg",
    "/Sliding/bus-1.jpeg",
    "/Sliding/bus2.jpg",
    "/Sliding/bus3.png",
    "/Sliding/bus4.png",
    "/Sliding/bus5.webp",
    "/Sliding/bus6.png",
  ];

  const couponImg = [
    "/Sliding/token-1.jpeg",
    "/Sliding/coupon1.webp",

    "/Sliding/token-2.jpeg",
    // "/Sliding/coupon3.jpeg",
    // "/Sliding/coupon4.jpeg",
  ];

  const imagesMobile = [
    "/Sliding/bus-m-1.jpg",
    "/Sliding/bus-m-4.jpg",
    "/Sliding/bus-m-2.jpg",
    "/Sliding/bus-m-5.jpg",
    "/Sliding/bus-m-3.jpg",
    "/Sliding/bus-m-6.jpg",
  ];

  function SwitchButton() {
    return (
      <motion.div
        onClick={() => {
          setRotated(true);
          let v = boarding;
          setBoarding(dropping);
          setDropping(v);
        }}
        initial={{ rotate: 0 }}
        animate={{
          rotate: rotated ? 180 : 0,
          boxShadow: rotated
            ? `
              0px 0px 18px rgba(80,80,80,0.9),
              0px 0px 40px rgba(120,120,120,0.7),
              0px 10px 30px rgba(60,60,60,0.5)
            `
            : `
              0px 0px 12px rgba(120,120,120,0.6),
              0px 6px 20px rgba(90,90,90,0.45),
              inset 0px 0px 8px rgba(255,255,255,0.3)
            `,
        }}
        whileHover={{
          scale: 1.08,
        }}
        whileTap={{
          scale: 0.92,
        }}
        transition={{
          rotate: {
            duration: 0.65,
            ease: "easeInOut",
          },
          boxShadow: {
            duration: 0.4,
          },
        }}
        style={{
          width: "100%",
          height: "100%",
          borderRadius: "50%",
          background: "#f5f5f5",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          position: "relative",
          overflow: "hidden",
          padding: 3,
        }}
      >
        {/* Deep animated grey glow */}
        <motion.div
          animate={{
            scale: [1, 1.2, 1],
            opacity: [0.35, 0.75, 0.35],
          }}
          transition={{
            duration: 2.2,
            repeat: Infinity,
            ease: "easeInOut",
          }}
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            borderRadius: "50%",
            background: "rgba(140,140,140,0.35)",
            filter: "blur(6px)",
            zIndex: 0,
          }}
        />

        <img
          src="/Assets/switch.png"
          alt="switch"
          style={{
            width: "32px",
            zIndex: 2,
            userSelect: "none",
            pointerEvents: "none",
            filter: "drop-shadow(0px 2px 4px rgba(80,80,80,0.6))",
          }}
        />
      </motion.div>
    );
  }

  const settings = {
    dots: false,
    infinite: true,
    speed: 1600,
    autoplay: true,
    autoplaySpeed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true, // smooth fade transition
    arrows: false,
  };

  const settings2 = {
    dots: false,
    infinite: true,
    speed: 500, // slide animation speed (ms)
    slidesToShow: 3, // show only one at a time
    slidesToScroll: 1,
    autoplay: true, // enable auto slide
    autoplaySpeed: 1000, // delay before next slide (ms)   // smooth continuous motion
    pauseOnHover: false,
    arrows: false, // hide arrows
  };

  const settings3 = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: mobile ? 1 : 4.5, // 👈 show 4 images at once
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024, // for tablets
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768, // for mobile
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480, // for small phones
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const settings4 = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: mobile ? 1 : 3.5, // 👈 show 4 images at once
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024, // for tablets
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768, // for mobile
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480, // for small phones
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const cardList = [
    "/Sliding/card-1.png",
    "/Sliding/card-2.png",
    "/Sliding/card-3.png",
    "/Sliding/card-4.png",
    "/Sliding/card-5.png",
    "/Sliding/card-6.png",
    "/Sliding/card-7.png",
    "/Sliding/card-8.png",
    "/Sliding/card-9.png",
    "/Sliding/card-10.png",
  ];

  const offerList = [
    "/Sliding/offer-1.png",
    "/Sliding/offer-2.png",
    "/Sliding/offer-3.png",
    "/Sliding/offer-4.png",
    "/Sliding/offer-5.png",
  ];

  const handleScroll = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const handleAddBooking = async() => {
    if (!token) {
      navigate("/login");
      return
    }

    const data = { boarding, dropping, time };
    dispatch(setPlan(data));
    if(boarding&& dropping&& time ){
       navigate("/bus-booking");
    }
   
  };

  const controlHeader = () => {
    if (typeof window !== "undefined") {
      if (window.scrollY > lastScrollY && window.scrollY > 80) {
        // scrolling down
        setShowHeader(false);
      } else {
        // scrolling up
        setShowHeader(true);
      }
      setLastScrollY(window.scrollY);
    }
  };

  const handleCitysearch = async ({ query, from }) => {
    if (!query || !from) {
      return;
    }
    if(query===" "){
      return
    }
    try {
      let data = {
        query,
        from,
        token,
      };
      const response = await searchCities(data);
      console.log(response);
      if (response.status === 200) {
        if (from === "from") {
          setFromCity(response.data.cities);
        } else {
          setDestinationCity(response.data.cities);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", controlHeader);
    return () => {
      window.removeEventListener("scroll", controlHeader);
    };
  }, [lastScrollY]);

  useEffect(() => {
    handleCitysearch(boarding, "from");
  }, [boarding]);

  useEffect(() => {
    handleCitysearch(dropping, "to");
  }, [dropping]);

  return (
    <div
      className="home-page"
      style={{ maxWidth: "100vw", overflowX: "hidden", width: "100%" }}
    >
      <div
        style={{
          position: "fixed",
          top: showHeader ? "0" : "-80px", // hide smoothly
          left: 0,
          right: 0,
          transition: "top 0.3s ease-in-out",
          zIndex: 100000000,
          borderBottom: "1px solid rgba(255,255,255,0.2)",
          backdropFilter: "blur(10px)", // blur background
          background: "rgba(255, 255, 255, 0.3)", // transparent glass
          WebkitBackdropFilter: "blur(10px)", // for Safari
        }}
      >
        <Header />
      </div>

      <section
        className="hero-section"
        id="start"
        style={{ maxWidth: mobile ? "100%" : "100%", position: "relative" }}
      >
        {mobile ? (
          <div style={{ position: "relative", height: "70vh", width: "100%" }}>
            <Slider {...settings}>
              {imagesMobile.map((img, i) => (
                <div key={i}>
                  <div
                    style={{
                      height: "70vh",
                      width: "100%",
                      backgroundImage: `url(${img})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                    }}
                  />
                </div>
              ))}
            </Slider>
            <div
              className="hero-content"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "70vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",

                color: "white",
                textAlign: "center",
                paddingBottom: "20vh",
              }}
            >
              <motion.h1
                initial={{ opacity: 0, x: -50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{
                  duration: 0.8,
                  ease: "easeOut",
                }}
                className="hero-title"
                style={{ zIndex: 100, fontSize: "35px" }}
              >
                Explore a new world !
              </motion.h1>

              <motion.p
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{
                  duration: 0.8,
                  ease: "easeOut",
                }}
                className="hero-subtitle"
                style={{ zIndex: 100, fontSize: "18px" }}
              >
                Smart routes, quick payments, and real-time bus updates — all in
                one place.
              </motion.p>
            </div>
          </div>
        ) : (
          <div style={{ position: "relative", height: "90vh", width: "100%" }}>
            <Slider {...settings}>
              {images.map((img, i) => (
                <div key={i}>
                  <div
                    style={{
                      position: "relative",
                      height: "98vh",
                      width: "100%",
                      overflow: "hidden",
                    }}
                  >
                    {/* Background Image */}
                    <div
                      style={{
                        position: "absolute",
                        inset: 0,
                        backgroundImage: `url(${img})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        filter: "blur(0px)", // blur amount
                        transform: "scale(1.05)", // avoid edge cut after blur
                      }}
                    />

                    {/* Dark Overlay */}
                    {/* <div
          style={{
            position: "absolute",
            inset: 1,
            backgroundColor: "rgba(39, 39, 39, 0.32)", // darkness level
          }}
        /> */}
                  </div>
                </div>
              ))}
            </Slider>

            <div
              className="hero-content"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "70vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",

                color: "white",
                textAlign: "center",
              }}
            >
              <motion.h1
                initial={{ opacity: 0, y: -50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 2, ease: "easeOut" }}
                className="hero-title"
                style={{
                  zIndex: 100,
                  fontSize: "70px",
                  textShadow:
                    "0 0 5px rgb(187, 187, 187), 0 0 10px rgb(54, 54, 54), 0 0 15px rgb(54, 54, 54)",
                }}
              >
                Explore a new world !
              </motion.h1>

              <motion.p
                initial={{ opacity: 0, y: 0 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 2, ease: "easeOut" }}
                className="hero-subtitle"
                style={{
                  zIndex: 100,
                  fontSize: "25px",
                  textShadow:
                    "0 0 10px white, 0 0 20px rgb(54, 54, 54), 0 0 30px rgb(54, 54, 54)",
                }}
              >
                Smart routes, quick payments, and real-time bus updates — all in
                one place.
              </motion.p>
            </div>
          </div>
        )}

        <section
          className="booking-section"
          id="booking"
          style={{
            position: "absolute",
            bottom: mobile ? "20vh" : "25vh",
            zIndex: 9999,
            left: mobile ? "5vw" : "10vw",
          }}
        >
          <div className="booking-container">
            {mobile ? (
              <motion.div
                initial={{ y: 0, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{
                  duration: 1.5,
                  ease: "easeOut",
                }}
                style={{
                  padding: "5px 10px",
                  borderRadius: "10px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  maxWidth: "99vw",
                  minWidth: "80vw",
                  paddingBottom: "20px",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    backgroundColor: "white",
                    borderRadius: "10px",
                    border: "1px solid gray",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.3)",
                  }}
                >
                  <div style={{ padding: "5px ", position: "relative" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <img
                        src="/Assets/bus-entry.png"
                        style={{ width: "15px", height: "15px" }}
                      />
                      <div>
                        <p
                          style={{
                            fontWeight: "700",
                            color: "gray",
                            fontSize: "8px",
                          }}
                        >
                          from
                        </p>
                        <input
                          style={{
                            fontSize: "12px",
                            fontWeight: "700",
                            outline: "none",
                            border: "none",
                            maxWidth: "50px",
                          }}
                          value={boarding}
                          onChange={(e) => {
                            setBoarding(e.target.value);
                            handleCitysearch({
                              query: e.target.value,
                              from: "from",
                            });
                          }}
                          placeholder="Enter"
                        />
                      </div>
                    </div>
                    {fromCity.length > 0 && (
                      <div
                        className="hide-scrollbar"
                        style={{
                          position: "absolute",
                          zIndex: 1000,
                          backgroundColor: "#acaaaaff",
                          height: "50px",
                          padding: "2px",
                          borderRadius: "10px",
                          top: "-50px",
                          width: "100px",
                          overflowY: "auto",
                        }}
                      >
                        {fromCity.map((item) => (
                          <div
                            style={{
                              borderRadius: "5px",
                              padding: "3px",
                              border: "0.3px solid grey",
                              backgroundColor: "white",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setBoarding(item.name);
                              setFromCity([]);
                            }}
                          >
                            <p
                              style={{
                                fontSize: "12px",
                                fontWeight: "700",
                                color: "#3a3939ff",
                              }}
                            >
                              {item.name}
                            </p>
                            <p
                              style={{
                                fontSize: "8px",
                                fontWeight: "600",
                                color: "#616161ff",
                              }}
                            >
                              {item.state}
                            </p>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  <div
                    style={{
                      padding: "5px ",
                      borderLeft: "1px solid gray",
                      position: "relative",
                      paddingLeft: "26px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <img
                        src="/Assets/bus-exit.png"
                        style={{ width: "15px", height: "15px" }}
                      />
                      <div>
                        <p
                          style={{
                            fontWeight: "700",
                            color: "gray",
                            fontSize: "8px",
                          }}
                        >
                          to
                        </p>
                        <input
                          style={{
                            fontSize: "12px",
                            fontWeight: "700",
                            outline: "none",
                            border: "none",
                            maxWidth: "50px",
                          }}
                          value={dropping}
                          onChange={(e) => {
                            setDropping(e.target.value);
                            handleCitysearch({
                              query: e.target.value,
                              from: "to",
                            });
                          }}
                          placeholder="Enter "
                        />
                      </div>
                    </div>
                    {destinationCity.length > 0 && (
                      <div
                        className="hide-scrollbar"
                        style={{
                          position: "absolute",
                          zIndex: 1000,
                          backgroundColor: "#acaaaaff",
                          height: "50px",
                          padding: "2px",
                          borderRadius: "10px",
                          top: "-50px",
                          width: "100px",
                          overflowY: "auto",
                        }}
                      >
                        {destinationCity.map((item) => (
                          <div
                            style={{
                              borderRadius: "5px",
                              padding: "3px",
                              border: "0.3px solid grey",
                              backgroundColor: "white",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setDropping(item.name);
                              setDestinationCity([]);
                            }}
                          >
                            <p
                              style={{
                                fontSize: "12px",
                                fontWeight: "700",
                                color: "#3a3939ff",
                              }}
                            >
                              {item.name}
                            </p>
                            <p
                              style={{
                                fontSize: "8px",
                                fontWeight: "600",
                                color: "#616161ff",
                              }}
                            >
                              {item.state}
                            </p>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  <div style={{ padding: "2px", borderLeft: "1px solid gray" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <div>
                        <p
                          style={{
                            fontWeight: "700",
                            color: "gray",
                            fontSize: "8px",
                          }}
                        >
                          Date of Journey
                        </p>
                        <input
                          style={{
                            fontSize: "12px",
                            fontWeight: "700",
                            outline: "none",
                            border: "none",
                            backgroundColor: "transparent",
                            maxWidth: "90px",
                            minWidth: "90px",
                          }}
                          value={time}
                          onChange={(e) => setTime(e.target.value)}
                          type="date"
                          ref={inputRef}
                          onClick={() => inputRef.current.showPicker()}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <motion.div
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.95 }}
                  style={{
                    position: "absolute",
                    marginTop: "38px",
                    cursor: "pointer",
                    padding: "5px 20px",
                    backgroundColor: "#222745",
                    display: "flex",
                    alignItems: "center",
                    gap: "15px",
                    borderRadius: "10px",
                  }}
                  onClick={handleAddBooking}
                >
                  {/* <img src='/Assets/search.png' style={{width:"14px",height:"14px"}}/> */}
                  <p
                    style={{
                      fontSize: "12px",
                      color: "white",
                      fontWeight: "500",
                    }}
                  >
                    Search
                  </p>
                </motion.div>
              </motion.div>
            ) : (
              <motion.div
                initial={{ y: 0, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{
                  duration: 1.5,
                  ease: "easeOut",
                }}
                style={{
                  padding: "20px 30px",
                  borderRadius: "10px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  paddingBottom: "40px",
                }}
              >
                <div>
                  <div
                    style={{
                      width: "100%",
                      borderRadius: "10px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: "20px",
                    }}
                  >
                    <div
                      style={{
                        padding: "10px 16px ",
                        position: "relative",
                        backgroundColor: "white",
                        boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.3)",
                        borderRadius: "10px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "15px",
                          position: "relative",
                        }}
                      >
                        <img
                          src="/Assets/bus-entry.png"
                          style={{ width: "20px", height: "20px" }}
                        />
                        <div>
                          <p
                            style={{
                              fontWeight: "700",
                              color: "gray",
                              fontSize: "14px",
                            }}
                          >
                            from
                          </p>
                          <input
                            style={{
                              fontSize: "18px",
                              fontWeight: "700",
                              outline: "none",
                              border: "none",
                            }}
                            value={boarding}
                            onChange={(e) => {
                              setBoarding(e.target.value);
                              handleCitysearch({
                                query: e.target.value,
                                from: "from",
                              });
                            }}
                            placeholder="Enter  place"
                          />
                        </div>
                        {fromCity.length > 0 && (
                          <div
                            className="hide-scrollbar"
                            style={{
                              position: "absolute",
                              backgroundColor: "rgb(231, 229, 229)",
                              height: "fit-content",
                              padding: "3px",
                              borderRadius: "6px",
                              left: 0,
                              top: "50px",
                              width: "100%",
                              overflowY: "auto",
                            }}
                          >
                            {fromCity.map((item) => (
                              <div
                                style={{
                                  borderRadius: "8px",
                                  padding: "5px",
                                  border: "0.3px solid grey",
                                  backgroundColor: "white",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  setBoarding(item.name);
                                  setFromCity([]);
                                }}
                              >
                                <p
                                  style={{
                                    fontSize: "15px",
                                    fontWeight: "700",
                                    color: "rgb(83, 83, 83)",
                                  }}
                                >
                                  {item.name}
                                </p>
                                <p
                                  style={{
                                    fontSize: "10px",
                                    fontWeight: "600",
                                    color: "#616161ff",
                                  }}
                                >
                                  {item.state}
                                </p>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                    <div>
                      <SwitchButton />
                    </div>

                    <div
                      style={{
                        padding: "10px 16px",
                        borderLeft: "1px solid gray",
                        position: "relative",
                        paddingLeft: "26px",
                        backgroundColor: "white",
                        boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.3)",
                        borderRadius: "10px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "15px",
                        }}
                      >
                        <img
                          src="/Assets/bus-exit.png"
                          style={{ width: "20px", height: "20px" }}
                        />
                        <div>
                          <p
                            style={{
                              fontWeight: "700",
                              color: "gray",
                              fontSize: "14px",
                            }}
                          >
                            to
                          </p>
                          <input
                            style={{
                              fontSize: "18px",
                              fontWeight: "700",
                              outline: "none",
                              border: "none",
                            }}
                            value={dropping}
                            onChange={(e) => {
                              setDropping(e.target.value);
                              handleCitysearch({
                                query: e.target.value,
                                from: "to",
                              });
                            }}
                            placeholder="Enter place"
                          />
                        </div>
                        {destinationCity.length > 0 && (
                          <div
                            className="hide-scrollbar"
                            style={{
                              position: "absolute",
                              backgroundColor: "rgb(231, 229, 229)",
                              height: "fit-content",
                              padding: "3px",
                              borderRadius: "6px",
                              left: 0,
                              top: "52px",
                              width: "100%",
                              overflowY: "auto",
                            }}
                          >
                            {destinationCity.map((item) => (
                              <div
                                style={{
                                  borderRadius: "8px",
                                  padding: "5px",
                                  border: "0.3px solid grey",
                                  backgroundColor: "white",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  setDropping(item.name);
                                  setDestinationCity([]);
                                }}
                              >
                                <p
                                  style={{
                                    fontSize: "15px",
                                    fontWeight: "700",
                                    color: "rgb(105, 104, 104)",
                                  }}
                                >
                                  {item.name}
                                </p>
                                <p
                                  style={{
                                    fontSize: "10px",
                                    fontWeight: "600",
                                    color: "#616161ff",
                                  }}
                                >
                                  {item.state}
                                </p>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>

                    <div
                      style={{
                        padding: "10px 16px",
                        borderLeft: "1px solid gray",
                        backgroundColor: "white",
                        boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.3)",
                        borderRadius: "10px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "15px",
                        }}
                      >
                        <div>
                          <p
                            style={{
                              fontWeight: "700",
                              color: "gray",
                              fontSize: "14px",
                            }}
                          >
                            Date of Journey
                          </p>

                          <input
                            type="date"
                            value={time}
                            min={today}
                            onChange={(e) => setTime(e.target.value)}
                            ref={inputRef}
                            onClick={() => inputRef.current?.showPicker()}
                            style={{
                              fontSize: "18px",
                              fontWeight: "700",
                              outline: "none",
                              border: "none",
                              backgroundColor: "transparent",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <motion.div
                      whileHover={{ scale: 1.1 }}
                      whileTap={{ scale: 0.95 }}
                      style={{
                        cursor: "pointer",
                        padding: "16px 30px",
                        backgroundColor: "#222745",
                        display: "flex",
                        alignItems: "center",
                        gap: "15px",
                        borderRadius: "10px",
                        boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.3)",
                      }}
                      onClick={handleAddBooking}
                    >
                      <img
                        src="/Sliding/search.png"
                        style={{ width: "20px", height: "20px" }}
                      />
                      <p
                        style={{
                          fontSize: "20px",
                          color: "white",
                          fontWeight: "500",
                        }}
                      >
                        Search
                      </p>
                    </motion.div>
                  </div>
                </div>
              </motion.div>
            )}
          </div>
        </section>
      </section>

      <section className="about-section" id="about">
        <div className="about-container">
          {mobile ? (
            <div className="about-stats">
              <div className="stat-item">
                <video
                  autoPlay
                  loop
                  muted
                  playsInline
                  style={{
                    borderRadius: "10px",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "cover", // fills div without stretching
                    zIndex: 10,
                  }}
                  src="/Sliding/bus-video.mp4"
                />
              </div>
              <button
                className="get-started-btn-about"
                style={{
                  fontSize: mobile ? "25px" : "1rem",
                  padding: mobile ? "15px 20px" : "20px",
                }}
                onClick={() => handleScroll("booking")}
              >
                Get Started
              </button>
            </div>
          ) : (
            <div className="about-stats">
              <video
                autoPlay
                loop
                muted
                playsInline
                style={{
                  borderRadius: "10px",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover", // fills div without stretching
                  zIndex: 10,
                }}
                src="/Sliding/bus-video.mp4"
              />
            </div>
          )}

          <div className="about-content">
            <h1
              className="about-title"
              style={{ fontSize: mobile ? "20px" : "2.5rem" }}
            >
              About Us
            </h1>
            <p
              className="about-text"
              style={{ fontSize: mobile ? "15px" : "1rem" }}
            >
              At ROAMJSSLN PVT. LTD, we're redefining the way people travel by bus. Our
              mission is to make bus booking simple, fast, and reliable — so you
              can focus on your journey, not the hassle of planning it. We
              partner with trusted bus operators across the country to bring you
              the widest network of routes, competitive prices, and real-time
              updates. Whether you're commuting daily or exploring a new
              destination, we ensure your travel experience is safe, seamless,
              and stress-free.
            </p>
          </div>
        </div>
      </section>

      {/* <section style={{backgroundColor:"white",padding:"20px"}}>
        <p style={{fontSize:mobile?"20px":"30px",padding:"15px",fontWeight:"700"}}>Offers for you</p>
        <Slider {...settings3}>
        {cardList.map((img, i) => (
          <div key={i} style={{ padding: "0 10px", }}>
            <img
              src={img}
              alt={`slide-${i}`}
              style={{
                width: "100%",
                height: "190px",
                borderRadius: "10px",
                objectFit: "contain",
              }}
            />
          </div>
        ))}
      </Slider>


      </section> */}
      <section style={{ backgroundColor: "white", padding: "30px" }}>
        <div
          style={{
            margin: "20px 50px",
            backgroundColor: "#b4e1ff",
            borderRadius: "14px",
            padding: "20px",
            border: "0.4px solid #94cef5",
          }}
        >
          <p
            style={{ fontSize: "22px", fontWeight: "700", textAlign: "center" }}
          >
            Why Choose Our buses?
          </p>

          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              gap: "20px",
              padding: "30px",
              flexDirection: mobile ? "column" : "row",
            }}
          >
            <div
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-10px)";
                e.currentTarget.style.boxShadow =
                  "-8px 10px 18px rgba(0,0,0,0.3)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "-6px 6px 14px rgba(0,0,0,0.25)";
              }}
              style={{
                width: mobile ? "150px" : "320px",
                borderRadius: "14px",

                padding: "20px",
                cursor: "pointer",
                backgroundColor: "#ffffff",
                boxShadow: "-6px 6px 14px rgba(0,0,0,0.25)", // left + bottom
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
            >
              <p
                style={{
                  fontSize: "20px",
                  fontWeight: "700",
                  textAlign: "center",
                }}
              >
                Comfort Guarentee
              </p>
              <p style={{ color: "#9b9999", textAlign: "center" }}>
                All regular maintained for optimal comfort
              </p>
            </div>

            <div
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-10px)";
                e.currentTarget.style.boxShadow =
                  "-8px 10px 18px rgba(0,0,0,0.3)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "-6px 6px 14px rgba(0,0,0,0.25)";
              }}
              style={{
                width: mobile ? "150px" : "320px",
                borderRadius: "14px",

                padding: "20px",
                cursor: "pointer",
                backgroundColor: "#ffffff",
                boxShadow: "-6px 6px 14px rgba(0,0,0,0.25)", // left + bottom
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
            >
              <p
                style={{
                  fontSize: "20px",
                  fontWeight: "700",
                  textAlign: "center",
                }}
              >
                Hygiene First
              </p>
              <p style={{ color: "#9b9999", textAlign: "center" }}>
                Daily deep cleaning and sanitization process
              </p>
            </div>

            <div
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-10px)";
                e.currentTarget.style.boxShadow =
                  "-8px 10px 18px rgba(0,0,0,0.3)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "-6px 6px 14px rgba(0,0,0,0.25)";
              }}
              style={{
                width: mobile ? "150px" : "320px",
                borderRadius: "14px",

                padding: "20px",
                cursor: "pointer",
                backgroundColor: "#ffffff",
                boxShadow: "-6px 6px 14px rgba(0,0,0,0.25)", // left + bottom
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
            >
              <p
                style={{
                  fontSize: "20px",
                  fontWeight: "700",
                  textAlign: "center",
                }}
              >
                One-time Service
              </p>
              <p style={{ color: "#9b9999", textAlign: "center" }}>
                95% of oue buses arrive within 15 minutes of schedule
              </p>
            </div>

            <div
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-10px)";
                e.currentTarget.style.boxShadow =
                  "-8px 10px 18px rgba(0,0,0,0.3)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "-6px 6px 14px rgba(0,0,0,0.25)";
              }}
              style={{
                width: mobile ? "150px" : "320px",
                borderRadius: "14px",

                padding: "20px",
                cursor: "pointer",
                backgroundColor: "#ffffff",
                boxShadow: "-6px 6px 14px rgba(0,0,0,0.25)", // left + bottom
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
            >
              <p
                style={{
                  fontSize: "20px",
                  fontWeight: "700",
                  textAlign: "center",
                }}
              >
                24/7 Support
              </p>
              <p style={{ color: "#9b9999", textAlign: "center" }}>
                Round-the-clock customer service assistance
              </p>
            </div>
          </div>
        </div>
      </section>

      <section style={{ backgroundColor: "white", padding: "30px" }}>
        <p
          style={{
            textAlign: "center",
            fontSize: "24px",
            fontWeight: "700",
            margin: "10px",
          }}
        >
          Book Tickets in 3 Easy Steps
        </p>
        <p
          style={{
            textAlign: "center",
            fontSize: "18px",
            fontWeight: "700",
            color: "#919090",
            margin: "10px",
          }}
        >
          Simple, fast, and secure bus ticket booking process
        </p>

        <div
          style={{
            display: "flex",
            flexDirection: mobile ? "column" : "row",
            justifyContent: "space-between",
            gap: "20px",
            borderBottom: "5px solid #63bffc",
            padding: "30px 70px",
          }}
        >
          <div>
            {" "}
            <div
              style={{
                position: "relative",
                padding: "30px",
                border: "10px solid #63bffc",
                borderRadius: "50%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <img src="/Assets/search.png" />
              <p
                style={{
                  position: "absolute",
                  top: "0",
                  right: "10px",
                  zIndex: 1000,
                  color: "#ffffff",
                  backgroundColor: "#63bffc",
                  padding: "10px",
                  borderRadius: "50%",
                  fontWeight: "800",
                }}
              >
                1st
              </p>
            </div>
            {mobile && (
              <div style={{ width: "200px" }}>
                <p
                  style={{
                    textAlign: "center",
                    fontSize: "20px",
                    fontWeight: "600",
                  }}
                >
                  Search Your Bus
                </p>
                <p style={{ textAlign: "center", fontWeight: "600" }}>
                  Choose your origin, destination, and travel dates, then search
                  for available buses.
                </p>
              </div>
            )}
          </div>

          <div>
            <div
              style={{
                position: "relative",
                padding: "30px",
                border: "10px solid #63bffc",
                borderRadius: "50%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <img src="/Assets/ticket.png" />
              <p
                style={{
                  position: "absolute",
                  top: "0",
                  right: "10px",
                  zIndex: 1000,
                  color: "#ffffff",
                  backgroundColor: "#63bffc",
                  padding: "10px",
                  borderRadius: "50%",
                  fontWeight: "800",
                }}
              >
                2nd
              </p>
            </div>
            {mobile && (
              <div style={{ width: "200px" }}>
                <p
                  style={{
                    textAlign: "center",
                    fontSize: "20px",
                    fontWeight: "600",
                  }}
                >
                  Search Your Bus
                </p>
                <p style={{ textAlign: "center", fontWeight: "600" }}>
                  Choose your origin, destination, and travel dates, then search
                  for available buses.
                </p>
              </div>
            )}
          </div>

          <div>
            <div
              style={{
                position: "relative",
                padding: "30px",
                border: "10px solid #63bffc",
                borderRadius: "50%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <img src="/Assets/credit-card.png" />
              <p
                style={{
                  position: "absolute",
                  top: "0",
                  right: "10px",
                  zIndex: 1000,
                  color: "#ffffff",
                  backgroundColor: "#63bffc",
                  padding: "10px",
                  borderRadius: "50%",
                  fontWeight: "800",
                }}
              >
                3rd
              </p>
            </div>
            {mobile && (
              <div style={{ width: "200px" }}>
                <p
                  style={{
                    textAlign: "center",
                    fontSize: "20px",
                    fontWeight: "600",
                  }}
                >
                  Search Your Bus
                </p>
                <p style={{ textAlign: "center", fontWeight: "600" }}>
                  Choose your origin, destination, and travel dates, then search
                  for available buses.
                </p>
              </div>
            )}
          </div>
        </div>

        {!mobile && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "0px 30px",
            }}
          >
            <div style={{ width: "300px" }}>
              <p
                style={{
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "600",
                }}
              >
                Search Your Bus
              </p>
              <p style={{ textAlign: "center", fontWeight: "600" }}>
                Choose your origin, destination, and travel dates, then search
                for available buses.
              </p>
            </div>

            <div style={{ width: "300px" }}>
              <p
                style={{
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "600",
                }}
              >
                Choose The Ticket
              </p>
              <p style={{ textAlign: "center", fontWeight: "600" }}>
                Select the best bus and ticket options that suit your journey.
              </p>
            </div>

            <div style={{ width: "300px" }}>
              <p
                style={{
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "600",
                }}
              >
                Pay Bill
              </p>
              <p style={{ textAlign: "center", fontWeight: "600" }}>
                Complete your booking by making a secure payment online.
              </p>
            </div>
          </div>
        )}

        <p
          style={{
            textAlign: "center",
            color: "#9c9a9a",
            fontWeight: "700",
            margin: "30px",
          }}
        >
          Ready to book your journey?
        </p>

        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            flexWrap: "wrap",
            gap: "40px",
            padding: "30px",
          }}
        >
          <p style={{ fontWeight: "600" }}>📞 24/7 support</p>
          <p style={{ fontWeight: "600" }}>🔒 Secure Payment</p>
          <p style={{ fontWeight: "600" }}>⚡ Instant Confirmation</p>
          <p style={{ fontWeight: "600" }}>🚫 Easy Cancellation</p>
        </div>
      </section>

      <section style={{ backgroundColor: "white", padding: "20px" }}>
        <p
          style={{
            fontSize: mobile ? "20px" : "30px",
            padding: "15px",
            fontWeight: "700",
          }}
        >
          What's new
        </p>
        <Slider {...settings4}>
          {offerList.map((img, i) => (
            <div key={i} style={{ padding: "0 10px" }}>
              <img
                src={img}
                alt={`slide-${i}`}
                style={{
                  width: "100%",
                  height: "200px",
                  borderRadius: "10px",
                  objectFit: "contain",
                }}
              />
            </div>
          ))}
        </Slider>
      </section>

      <section className="how-it-works-section" id="workings">
        <div className="how-it-works-container">
          <h2 className="how-it-works-title">How it works?</h2>
          <div className="steps-grid">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: false, amount: 0.3 }}
              transition={{ duration: 2, ease: "easeOut" }}
              className="step-card step-card-dark"
            >
              <h3 className="step-title">Search Your Route</h3>
              <p className="step-description">
                Enter your departure and destination cities, select your travel
                dates, and hit search to explore available buses.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: false, amount: 0.3 }}
              transition={{ duration: 2, ease: "easeOut", delay: 0.6 }}
              className="step-card step-card-light"
              style={{ backgroundImage: `url(${stepBg1})` }}
            >
              <h3 className="step-title">Choose Your Bus</h3>
              <p className="step-description">
                Compare operators, timings, seat types, and prices — then pick
                the one that best fits your travel plan.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: false, amount: 0.3 }}
              transition={{ duration: 2, ease: "easeOut", delay: 1 }}
              className="step-card step-card-light"
              style={{ backgroundImage: `url(${stepBg1})` }}
            >
              <h3 className="step-title">Book & Pay Securely</h3>
              <p className="step-description">
                Confirm your seat and make payment through our secure gateway
                using cards, UPI, or wallets.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: false, amount: 0.3 }}
              transition={{ duration: 2, ease: "easeOut", delay: 1.5 }}
              className="step-card step-card-dark"
            >
              <h3 className="step-title">Get Instant E-Ticket</h3>
              <p className="step-description">
                Receive your e-ticket instantly via email or SMS, and you're all
                set to travel!
              </p>
            </motion.div>
          </div>

          <div className="verified-section">
            <div className="verified-number">5000+</div>
            <div className="verified-label">Verified bus operators</div>
          </div>
        </div>
      </section>

      <section className="special-deals-section" id="deals">
        <div className="special-deals-container">
          <h2 className="special-deals-title">
            Save More on Your Bus Bookings
          </h2>
          {mobile ? (
            <div className="coupons-grid">
              <Slider {...settings2}>
                {couponImg.map((img, i) => (
                  <div key={i}>
                    <img
                      src={img}
                      alt={`slide-${i}`}
                      style={{
                        width: "100%",
                        height: "20vw",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                ))}
              </Slider>
            </div>
          ) : (
            <div className="coupons-grid">
              {couponImg.map((img, i) => (
                <CouponCard imgUrl={img} />
              ))}
            </div>
          )}
        </div>
      </section>

      <FAQ />

      <Footer />
    </div>
  );
};

export default Home;
